module.exports = __webpack_public_path__ + "img/folder.e60cf021.png";